import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { addFunds } from '../fiatWalletEndpoints'
import { fiatWalletKeys } from '../fiatWalletQueryKeys'
import { transactionKeys } from '../../../transactions/api/transactionQueryKeys'

export function useAddFundsMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: addFunds,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: fiatWalletKeys.fiat() })
      // The fiat wallet activity feed (unified ledger) is owned by the
      // transactions sub-module — invalidate every list filter so the
      // history refreshes regardless of the active filter combination.
      qc.invalidateQueries({ queryKey: transactionKeys.lists() })
    },
  })
}
